<template>
  <div>

    <ChangeQtyModal
      v-if="modalChangeQtyData"
      :modalData="modalChangeQtyData"
      :onAccept="(data) => updateDrugQty(data)"
    />
    <table class="table table-hover table-bordered mt-0">
      <thead>
      <tr class="sticky">
        <th width="40px"></th>
        <th width="40px"></th>
        <th>Препарат</th>
        <th width="100px">Кол.</th>
        <th width="100px">Н.Кол.</th>
        <th width="70px">Сумма</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(prep, index) in sortedPrepNames(drugs)">
        <td>{{ index + 1 }}</td>
        <td>
          <span v-if="prep.cool" class="icon icon-snowflake"></span>
        </td>
        <td>
          {{ prep.title }} ({{ prep.id }})
          <p v-if="+prep.pack_set !== 1">комплект: <strong>{{ +prep.pack_set }}</strong> з.у.</p>
          <p class="pack_comment" v-if="prep.pack_comment">{{ prep.pack_comment }}</p>
          <p class="pack_box_comment" v-if="prep.pack_box_comment">{{ prep.pack_box_comment }}</p>
        </td>
        <td>{{ printPackSet(figures[prep.id], prep) }}</td>
        <td>{{ prep.comment ? printPackSet(prep.new_qty || null, prep) : null }}</td>
        <td>{{ printPrice(prep) }}</td>
        <td>
          <button @click="openChangeDrugBlock(prep)" class="btn btn-default comments_btn" type="button">
            <i class="icon-fa icon-fa-edit text-center"/>
            <span v-if="prep.comment"
                  class="badge badge-info">new</span>
          </button>
        </td>
      </tr>
      <tr>
        <td colspan="3"></td>
        <td>{{ drugs.reduce((acc, d) => acc + figures[d.id], 0) }}</td>
        <td></td>
        <td>{{ drugs.reduce((acc, d) => acc + printPrice(d), 0) }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import ChangeQtyModal from "@/views/admin/autolists/components/ChangeQtyModal";

export default {
  props: ['drugs', 'ignoredDrugs', 'figures'],
  components: {
    ChangeQtyModal,
  },
  data() {
    return {
      modalChangeQtyData: null,
    }
  },
  methods: {
    sortedPrepNames: function (drugs, request = false) {
      let sorted = _.orderBy(drugs.filter((d) => !this.ignoredDrugs[d.id]), "title");
      if (request) {
        sorted = sorted.filter(x => request[x.id]);
      }
      return sorted;
    },
    printPrice(prep) {
      return prep.price ? prep.price.price * this.figures[prep.id] : 0;
    },
    openChangeDrugBlock(drug) {
      this.modalChangeQtyData = {
        open: true,
        header: 'Редактирование количества препарата',
        drug: {
          ...drug,
          qty: this.figures[drug.id],
          remain: this.figures[drug.id]
        }
      }
    },
    updateDrugQty(data) {
      const index = this.drugs.findIndex((d) => d.id === data.drugId);
      if (index !== -1) {
        this.drugs[index].comment = data.comment;
        this.drugs[index].new_qty = data.new_qty;
      }
      this.modalChangeQtyData = null;
    },
  }
}

</script>

<style scoped>
table td {
  padding: 2px;
}

.pack_comment,
.pack_box_comment {
  font-size: 11px;
  margin-bottom: 2px;
}

.pack_comment {
  color: #02026d;
}

.icon-snowflake {
  display: inline-block;
  width: 15px;
  height: 17px;
  background: #5bbfde;
  margin: -3px 4px;
}

.pack_box_comment {
  color: #0d6d02;
}

</style>
